import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import './index.scss'
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import NavBar from "./components/navBar/NavBar";
import Login from "./pages/LoginPage/Login";
import HomePage from "./pages/HomePage/homePage";
import MoreAbout from "./pages/MoreAbout/moreAbout";
// import OpenPage from "./pages/openpage/openpage";
import PageQrCode from "./pages/pageqrcode/pageqrcode";
//import GraphicsPage from "./pages/Graphics/graphics";


function App() {
    const [contentHeight, setContentHeight] = useState(0);
    const [showSideBar, setShowSideBar] = useState(false);
    const user = useSelector((state) => state.user.data);
    const navigate = useNavigate();
    const location = useLocation();
    const hideNavBar = location.pathname.toLowerCase().startsWith("/qrcode/etiqueta/");
    //Calculate the height dynamically 
    useEffect(() => {
        // Function to calculate and set the height
        const calculateHeight = () => {
            const contentElement = document.getElementById('content');
            if (contentElement) {
                const height = contentElement.offsetHeight - 60; // Subtract 60 pixels
                setContentHeight(height);
            }
        };

        // Call the function initially and on window resize
        calculateHeight();
        window.addEventListener('resize', calculateHeight);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', calculateHeight);
        };
    }, []);

    const toggleSidebar = () => {
        setShowSideBar(!showSideBar);
    };

    useEffect(() => {
        const currentPath = window.location.pathname.toLowerCase();

        // Se não for a pagina em questão, faz a verificação do user
        if (!currentPath.includes("/qrcode/etiqueta/")) {
            if (user != null) {
                navigate("/Pages/HomePage/");
            } else {
                navigate("/Pages/LoginPage/");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <div className="App">
            <div className="App-header">
                <ToastContainer style={{ fontSize: "14px" }} />
                {!hideNavBar && <NavBar toggleSidebar={toggleSidebar} />}
                <div style={{ display: "flex" }}>
                    <div style={{ width: "100%", minHeight: `${contentHeight}px` }}
                    >
                        <Routes>
                            <Route path="/Pages/LoginPage/" element={<Login />} />
                            <Route path="/Pages/HomePage/*" element={<HomePage />} />
                            <Route path="/Pages/MoreAbout/*" element={<MoreAbout />} />
                            <Route path="/qrcode/etiqueta/*" element={<PageQrCode />} />
                            {/* <Route path="/qrcode/etiqueta/full/*" element={<PageQrCode />} /> */}
                            {/* <Route path="/Pages/graphics/" element={<GraphicsPage />} /> */}
                        </Routes>
                    </div>
                </div>
            </div>
        </div>
    );
}

function RouterApp() {
    return (
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
}

export default RouterApp;

